export default __webpack_public_path__ + "static/media/Ne.ff78705f.JPG";